import { useEffect, useState, useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

import "./Header.scss";

import { Button, COLORS, Modal, NavigationBar } from "abs-ui-components";
import { adminActions } from "../../store/admin/admin.slice";
import { ROUTE_WITH_TAB } from "./constants";
import axiosHttp from "../../services/interceptor";
import { setUserLoggedIn } from "../../store/userInfo/userInfo.slice";
import { ROLE_TYPES } from "../../constants/roles";
import { MENU_TITLES } from "../../constants/menuTitles";
import { ClaimsContext } from "../../services/ClaimsService";
import { ClaimType } from "../../constants/claims";
import { FeatureType } from "../../constants/FeatureToggles";
import * as _ from "lodash";
import logo from "../../images/abs-logo-white.svg";

const Header = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const {
		userHasClaim,
		userHasFeature,
		userClaimsAreLoaded,
		userFeaturesAreLoaded,
		resetClaims,
		fetchUserFeatures,
		checkWcnDelta
	} = useContext(ClaimsContext);
	const [selectedTab, setSelectedTab] = useState("");
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();
	const [userProfilePic, setUserProfilePic] = useState(null);
	const [isLogout, SetisLogout] = useState(false);
	let [navMenuData, setNavMenuData] = useState({});
	let pathname = window.location.pathname.split("/");
	pathname = pathname[1];

	const user = useSelector((state) => state.userInfo.userData);
	const email = user ? user?.email : null;
	const roles = user?.roles || [];
	const userSignIn = useSelector((state) => state.userInfo.isUserLoggedIn);
	const toggleLogout = () => {
		SetisLogout(!isLogout);
	};
	const handleSignout = async () => {
		try {
			const res = await axiosHttp.get("api/Accounts/SignOutUser");
			if (res.status === 200) {
				resetClaims();
				if (isAuthenticated) {
					localStorage.removeItem("authType");
					localStorage.removeItem("selectedTabIndex");

					instance.logoutRedirect({ postLogoutRedirectUri: "/" });
				} else if (userSignIn) {
					dispatch(setUserLoggedIn(false));
					navigate("/");
				}
			}

			// Check if the user is authenticated
		} catch (error) {
			console.error("Error during sign-out:", error);
		}
	};

	useEffect(() => {
		if (!userFeaturesAreLoaded) {
			fetchUserFeatures();
		}
	}, [userFeaturesAreLoaded, fetchUserFeatures]);

	const filterCompanyReport = (menuData, hasAccess) => {

		const filteredMenu = { ...menuData };

		if (!hasAccess && filteredMenu[MENU_TITLES.ANNUAL_EMISSION_VERIFICATION]?.children) {
			filteredMenu[MENU_TITLES.ANNUAL_EMISSION_VERIFICATION].children = filteredMenu[
				MENU_TITLES.ANNUAL_EMISSION_VERIFICATION
			].children.filter((item) => item.label !== MENU_TITLES.COMPANY_EMISSION_VERIFICATION_REPORT);
		}

		return filteredMenu;
	};
	useEffect(() => {

		const hasCompanyReportAccess = userHasClaim(ClaimType.VIEW_REPORT);
		var planVerificationEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.PlanVerification));
		var bulkExportEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.BulkExport));
		var unsatisfactoryCIIRatingExportEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.UnsatisfactoryCiiExport));
		var ciiCalculatorEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.CiiCalculator));

		var dashboardEnabled = (userFeaturesAreLoaded && userHasFeature(FeatureType.Dashboard));

		const clientData = {
			[MENU_TITLES.DASHBOARD]: {
				action: () => {
					navigate("/dashboard");
					setSelectedTab(MENU_TITLES.DASHBOARD);
				},
				width: 250,
			},
			[MENU_TITLES.MY_FLEET]: {
				action: () => {
					navigate("/my-fleet");
					setSelectedTab(MENU_TITLES.MY_FLEET);
				},
				width: 250,
			},
			[MENU_TITLES.ANNUAL_EMISSION_VERIFICATION]: {
				children: [
					...(planVerificationEnabled
						? [{
							action: () => {
								navigate("/plan-verification");
								setSelectedTab(MENU_TITLES.PLAN_VERIFICATION);
							},
							label: MENU_TITLES.PLAN_VERIFICATION,
						}]
						: []),
					{
						action: () => {
							navigate("/reports");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.REPORTS,
					},
					{
						action: () => {
							navigate("/eumrv-company-emission-verification-report");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.EUMRV_COMPANY_EMISSION_VERIFICATION_REPORT,
					},
					{
						action: () => {
							navigate("/port-codes");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.PORT_CODES,
					},
					...(ciiCalculatorEnabled
						? [{
							action: () => {
								navigate("/cii-calculations");
								setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
							},
							label: MENU_TITLES.CII_CALCULATIONS,
						}]
						: []),
				],
				width: 300,
			},
			[MENU_TITLES.ACCOUNT]: {
				children: [
					{
						action: () => {
							navigate("/manage-account");
							setSelectedTab(MENU_TITLES.ACCOUNT);
						},
						label: MENU_TITLES.MANAGE_MY_ACCOUNT,
					},
					{
						action: () => {
							navigate("/notification-settings");
							setSelectedTab(MENU_TITLES.ACCOUNT);
						},
						label: MENU_TITLES.NOTIFICATION_SETTINGS,
					},
				],
				width: 250,
			},
			Support: {
				children: [
					{
						action: () => {
							navigate("/support");
							setSelectedTab(MENU_TITLES.SUPPORT);
						},
						label: MENU_TITLES.HELP,
					},
				],
				width: 250,
			},
			"Sign out": {
				action: () => {
					toggleLogout();
				},
			},
		};

		const adminData = {
			[MENU_TITLES.DASHBOARD]: {
				action: () => {
					navigate("/dashboard");
					setSelectedTab(MENU_TITLES.DASHBOARD);
				},
				width: 250,
			},
			[MENU_TITLES.MY_FLEET]: {
				action: () => {
					navigate("/my-fleet");
					setSelectedTab(MENU_TITLES.MY_FLEET);
				},
				width: 250,
			},
			[MENU_TITLES.ANNUAL_EMISSION_VERIFICATION]: {
				children: [
					...(planVerificationEnabled
						? [{
							action: () => {
								navigate("/plan-verification");
								setSelectedTab(MENU_TITLES.PLAN_VERIFICATION);
							},
							label: MENU_TITLES.PLAN_VERIFICATION,
						}]
						: []),
					{
						action: () => {
							navigate("/reports");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.REPORTS,
					},
					{
						action: () => {
							navigate("/eumrv-company-emission-verification-report");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.EUMRV_COMPANY_EMISSION_VERIFICATION_REPORT,
					},
					{
						action: () => {
							navigate("/port-codes");
							setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
						},
						label: MENU_TITLES.PORT_CODES,
					},
					...(ciiCalculatorEnabled
						? [{
							action: () => {
								navigate("/cii-calculations");
								setSelectedTab(MENU_TITLES.ANNUAL_EMISSION_VERIFICATION);
							},
							label: MENU_TITLES.CII_CALCULATIONS,
						}]
						: []),
				],
				width: 300,
			},

			[MENU_TITLES.ADMIN]: {
				children: [
					{
						action: () => {
							navigate("/admin");
							setSelectedTab(MENU_TITLES.ADMIN);
							dispatch(
								adminActions.setSelectedTab({
									selectedTab: 0,
								})
							);
						},
						label: MENU_TITLES.MANAGE_USER,
					},
					{
						action: () => {
							navigate("/admin");
							setSelectedTab(MENU_TITLES.ADMIN);
							dispatch(
								adminActions.setSelectedTab({
									selectedTab: 2,
								})
							);
						},
						label: MENU_TITLES.MANAGE_WCN,
					},
					{
						action: () => {
							navigate("/eventlogs");
							setSelectedTab(MENU_TITLES.ADMIN);
						},
						label: MENU_TITLES.EVENT_LOGS,
					},
					...(bulkExportEnabled
						? [{
							action: () => {
								navigate("/bulk-export");
								setSelectedTab(MENU_TITLES.ADMIN);
							},
							label: MENU_TITLES.BULK_EXPORT,
						}]
						: []),
					...(unsatisfactoryCIIRatingExportEnabled
						? [{
							action: () => {
								navigate("/unsatisfactory-cii-ratings-vessel-export");
								setSelectedTab(MENU_TITLES.ADMIN);
							},
							label: MENU_TITLES.UNSATISFACTOTY_CII_RATINGS_VESSEL_EXPORT,
						}]
						: []),
			],
				width: 290,
			},

			[MENU_TITLES.ACCOUNT]: {
				children: [
					{
						action: () => {
							navigate("/manage-account");
							setSelectedTab(MENU_TITLES.ACCOUNT);
						},
						label: MENU_TITLES.MANAGE_MY_ACCOUNT,
					},
					{
						action: () => {
							navigate("/notification-settings");
							setSelectedTab(MENU_TITLES.ACCOUNT);
						},
						label: MENU_TITLES.NOTIFICATION_SETTINGS,
					},
				],
				width: 250,
			},
			[MENU_TITLES.SUPPORT]: {
				children: [
					{
						action: () => {
							navigate("/support");
							setSelectedTab(MENU_TITLES.SUPPORT);
						},
						label: MENU_TITLES.HELP,
					},
				],
				width: 250,
			},
			"Sign out": {
				action: () => {
					toggleLogout();
				},
			},
		};

		const filteredCompanyReportClientData = filterCompanyReport(clientData, hasCompanyReportAccess);
		const filteredCompanyReportAdminData = filterCompanyReport(adminData, hasCompanyReportAccess);

		const filteredClientData = _.chain(filteredCompanyReportClientData)
			.pickBy((value, key) => {
				// remove Dashboard when disabled
				if (key === MENU_TITLES.DASHBOARD && !dashboardEnabled) {
					return false;
				}
				return true;
			})
			.value();

		const filteredAdminData = _.chain(filteredCompanyReportAdminData)
			.pickBy((value, key) => {
				// remove Dashboard when disabled
				if (key === MENU_TITLES.DASHBOARD && !dashboardEnabled) {
					return false;
				}
				return true;
			})
			.value();

		if (email) {
			const emailprofile = email.substring(0, 2).toUpperCase();
			setUserProfilePic(emailprofile);
		}
		if (userClaimsAreLoaded && userHasClaim(ClaimType.VIEW_ADMIN)) {
			setNavMenuData(filteredAdminData);
		} else {
			setNavMenuData(filteredClientData);
		}
	}, [dispatch, email, navigate, userHasClaim, userHasFeature, userClaimsAreLoaded, userFeaturesAreLoaded]);

	useEffect(() => {
		const changedTab = ROUTE_WITH_TAB[pathname];
		setSelectedTab(changedTab);
	}, [pathname]);

	return (
		<div className="header-container">
			<div className="header-top">
				<div className="header-top-left">
					<img
								src={logo}
							/>
				</div>
				<div className="header-top-right">
					<div className="header-user-deatils">
						<label>{email}</label>
						<div className="user-icon">
							<span>{userProfilePic}</span>
						</div>
					</div>
				</div>
			</div>

			<div className="navigation">
				<NavigationBar
					data={navMenuData}
					zIndex={"10"}
					selected={selectedTab}
				/>
			</div>
			<Modal
				isOpen={isLogout}
				modalHeader
				padding={"70px"}
				headerHeight={"50px"}
				showFooter
				onCloseClickListener={() => {
					SetisLogout(false);
				}}
				footer={
					<div className="d-flex justify-content-end fixed-action-btns p-4">
						<Button
							className="modal-delete-btn"
							onClick={handleSignout}
							primaryColor={COLORS.RED.DARK}
							primaryBackgroundColor={COLORS.RED.LIGHT}
						>
							Sign out
						</Button>
						<Button
							className="modal-cancel-btn ml-2"
							variant="secondary"
							onClick={() => {
								SetisLogout(false);
							}}
						>
							Cancel
						</Button>
					</div>
				}
			>
				<div>Are you sure you want to sign out?</div>
			</Modal>
		</div>
	);
};

export default Header;
